import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * cn(...) — gộp class có điều kiện (clsx) + khử trùng lặp Tailwind (tailwind-merge).
 * Dùng cho toàn bộ UI kit.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export default cn;
